import {
  SignUpCommand,
  ConfirmSignUpCommand,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand,
  CognitoIdentityProviderClient,
  ListUsersCommand,
  AdminLinkProviderForUserCommand,
} from '@aws-sdk/client-cognito-identity-provider'
import { cognitoClient } from './cognitoClient'
import { jwtDecode } from 'jwt-decode'
import AuthSession from 'admin/utils/AuthSession'
import { AccountAssumption } from 'admin/utils/AccountAssumption'
import {
  CLIENT_ID,
  POOL_ID,
  COGNITO_DOMAIN,
} from 'components/Login/ConfigLoader'
import axios from 'axios'
import { getApiUrl } from 'utils/api/getApiUrl'

// console.log(CLIENT_ID)

function generatePassword(length = 12) {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+[]{}|;:,.<>?'
  let password = ''
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length)
    password += characters[randomIndex]
  }
  return password
}

function generateId() {
  const randomBytes = crypto.getRandomValues(new Uint8Array(16))

  // Modify specific bytes to conform to UUID version 4 standards
  randomBytes[6] = (randomBytes[6] & 0x0f) | 0x40 // Version 4
  randomBytes[8] = (randomBytes[8] & 0x3f) | 0x80 // Variant 1

  const id = [...randomBytes]
    .map(
      (byte, index) =>
        byte.toString(16).padStart(2, '0') +
        (index === 3 || index === 5 || index === 7 || index === 9 ? '-' : '')
    )
    .join('')

  return id
}

// Function to start the custom auth flow (OTP request)
// export const initiateCustomAuth = async (username) => {
//   console.log('inside initiate custom auth')
//   try {
//     const command = new InitiateAuthCommand({
//       ClientId: '3ri5ml6iffla1io1gnmplfdui4', // Your Cognito User Pool App Client ID
//       AuthFlow: 'CUSTOM_AUTH',
//       AuthParameters: {
//         USERNAME: username,
//       },
//     })
//     const response = await cognitoClient.send(command)
//     return response.Session // Store the session for use in the OTP step
//   } catch (error) {
//     console.error('Error initiating custom auth flow:', error)
//     throw error
//   }
// }

//OTHER INITIATE CUSTOM AUTH VERSION
export const initiateCustomAuth = async (username, otpLoginMethod) => {
  const apiUrl = getApiUrl()
  try {
    const checkRes = await axios.post(`${apiUrl}/api/checkUserExists`, {
      email: username.includes('@') ? username : undefined,
      phone: !username.includes('@') ? username : undefined,
    })

    if (!checkRes.data.exists) {
      const error = new Error('User not found.')
      Object.assign(error, { name: 'UserNotFoundException' })
      throw error
    }

    const cleanUsername = username.includes('@') ? username : `+1${username}`
    const command = new InitiateAuthCommand({
      ClientId: CLIENT_ID,
      // AuthFlow: 'CUSTOM_AUTH',
      AuthFlow: 'USER_AUTH',
      AuthParameters: {
        USERNAME: cleanUsername,
        PREFERRED_CHALLENGE:
          otpLoginMethod === 'email' ? 'EMAIL_OTP' : 'SMS_OTP',
      },
    })
    const response = await cognitoClient.send(command)
    // console.log(response)
    return response.Session // Store the session for use in the OTP step
  } catch (error) {
    console.error('Error initiating custom auth flow:', error)
    throw error
  }
}

export const signUpUser = async ({
  email,
  phone,
  firstName = '',
  lastName = '',
}) => {
  // console.log('signup initiated')
  const formattedPhone = '+1' + phone
  const username = generateId()
  const command = new SignUpCommand({
    ClientId: CLIENT_ID, // The User Pool App Client ID
    Username: username,
    Password: generatePassword(),
    UserAttributes: [
      { Name: 'email', Value: email },
      { Name: 'phone_number', Value: formattedPhone },
      { Name: 'given_name', Value: firstName },
      { Name: 'family_name', Value: lastName },
    ],
  })

  try {
    const response = await cognitoClient.send(command)
    return { ...response, username }
  } catch (error) {
    console.error('Error during signup:', error)
    throw error
  }
}

// export const respondToCustomChallenge = async (username, otp, session) => {
//   console.log('inside repond to custom auth challenge')
//   try {
//     const command = new RespondToAuthChallengeCommand({
//       ClientId: '3ri5ml6iffla1io1gnmplfdui4',
//       ChallengeName: 'CUSTOM_CHALLENGE',
//       Session: session, // The session token from the initiateAuth step
//       ChallengeResponses: {
//         USERNAME: username,
//         ANSWER: otp, // OTP that the user inputs
//       },
//     })
//     const response = await cognitoClient.send(command)

//     // Tokens (ID token, access token, refresh token) will be in AuthenticationResult
//     return response.AuthenticationResult
//   } catch (error) {
//     console.error('Error responding to custom challenge:', error)
//     throw error
//   }
// }

export const respondToCustomChallenge = async (
  username,
  otp,
  session,
  otpLoginMethod
) => {
  try {
    const cleanUsername = username.includes('@') ? username : `+1${username}`
    const codeParameter =
      otpLoginMethod === 'email'
        ? { EMAIL_OTP_CODE: otp }
        : { SMS_OTP_CODE: otp }
    const command = new RespondToAuthChallengeCommand({
      ClientId: CLIENT_ID,
      // ChallengeName: 'CUSTOM_CHALLENGE',
      ChallengeName: otpLoginMethod === 'email' ? 'EMAIL_OTP' : 'SMS_OTP',
      Session: session, // The session token from the initiateAuth step
      ChallengeResponses: {
        USERNAME: cleanUsername,
        // ANSWER: otp, // OTP that the user inputs
        ...codeParameter,
      },
    })
    const response = await cognitoClient.send(command)
    // console.log(response)

    // Tokens (ID token, access token, refresh token) will be in AuthenticationResult
    return response.AuthenticationResult
  } catch (error) {
    console.error('Error responding to custom challenge:', error)
    throw error
  }
}

// Example of storing tokens in local storage
export const handleSuccessfulLogin = async (tokens) => {
  // Calculate token expiration time
  const expirationTime = Date.now() + tokens.ExpiresIn * 1000

  await AuthSession.setItem('expirationTime', expirationTime.toString()) // Store expiration time
  await AuthSession.setItem('idToken', tokens.IdToken)
  await AuthSession.setItem('accessToken', tokens.AccessToken)
  await AuthSession.setItem('refreshToken', tokens.RefreshToken)
}

export const handleLogOut = async () => {
  await AccountAssumption.clearAll()
  await AuthSession.clearAll()
}

export const accessToken = async () => {
  return await AuthSession.getItem('accessToken')
}

// id, iss, cognito:groups, username, exp
// export const decodedToken = async () => {
//   const token = await AuthSession.getItem('accessToken')

//   try {
//     const decodedToken = jwtDecode(token)
//     // console.log('decodedToken', decodedToken)

//     // Determine if the user is federated by checking the issuer or groups
//     const isFederatedUser =
//       decodedToken['cognito:groups']?.some((group) =>
//         group.includes('Google')
//       ) || decodedToken.iss.includes('cognito-idp')
//     return {
//       isFederatedUser,
//       ...decodedToken,
//     }
//   } catch (e) {
//     console.error(e)
//     return {}
//   }
// }
export const decodedToken = async () => {
  try {
    let token = await AuthSession.getItem('accessToken')

    // If token missing or expired, try to refresh it
    const expirationTime = await AuthSession.getItem('expirationTime')
    const now = Date.now()
    const EXPIRATION_BUFFER = 5 * 60 * 1000 // 5 minutes buffer

    if (
      !token ||
      !expirationTime ||
      now >= parseInt(expirationTime) - EXPIRATION_BUFFER
    ) {
      console.log('Access token missing or expired, refreshing...')
      token = await refreshCognitoAccessToken().catch(() => null)
    }

    if (!token) {
      console.warn(
        'No valid access token found, returning empty decoded token.'
      )
      return {}
    }

    const decoded = jwtDecode(token)
    return {
      ...decoded,
      username:
        decoded['username'] || decoded['cognito:username'] || decoded['sub'],
      isFederatedUser:
        decoded['cognito:groups']?.some((g) => g.includes('Google')) ||
        decoded.iss?.includes('cognito-idp'),
    }
  } catch (e) {
    console.error('Error decoding token:', e)
    return {}
  }
}

export const refreshCognitoAccessToken = async () => {
  const refreshToken = await AuthSession.getItem('refreshToken')
  if (!refreshToken) {
    throw new Error('No refresh token available')
  }

  const params = new URLSearchParams()
  params.append('grant_type', 'refresh_token')
  params.append('client_id', CLIENT_ID)
  params.append('refresh_token', refreshToken)

  const tokenUrl = `https://${COGNITO_DOMAIN}/oauth2/token`

  const response = await fetch(tokenUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: params.toString(),
  })

  const data = await response.json()

  if (!response.ok) {
    console.error('Token refresh failed:', data)
    throw new Error('Refresh failed')
  }

  const { access_token, id_token, expires_in } = data

  await AuthSession.setItem('accessToken', access_token)
  await AuthSession.setItem('idToken', id_token)
  await AuthSession.setItem('expirationTime', Date.now() + expires_in * 1000)

  return access_token
}

export const getValidAccessToken = async () => {
  const expirationTime = await AuthSession.getItem('expirationTime')
  const token = await AuthSession.getItem('accessToken')
  const now = Date.now()

  const EXPIRATION_BUFFER = 5 * 60 * 1000

  if (
    !token ||
    !expirationTime ||
    now >= parseInt(expirationTime) - EXPIRATION_BUFFER
  ) {
    // console.log('→ token is missing or expired, refreshing...')
    return await refreshCognitoAccessToken()
  }

  return token
}

export const checkUserLoggedIn = async (navigate) => {
  try {
    const token = await getValidAccessToken()

    if (token) {
      const decoded = jwtDecode(token)
      const isExpired = decoded.exp * 1000 < Date.now()

      if (!isExpired) {
        // navigate('/dashboard')
        return
      }
    }

    // Token doesn't exist or is expired — stay on login
  } catch (error) {
    console.error('Error checking user login:', error)
    // stay on login
  }
}
